import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChat = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C13.8 22 15.5 21.5 17 20.6L22 22L20.7 17C21.5 15.5 22 13.8 22 12Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9951 12H17.0051",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9951 12H12.0051",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.99512 12H7.00512",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 12.5C17.2761 12.5 17.5 12.2761 17.5 12C17.5 11.7239 17.2761 11.5 17 11.5C16.7239 11.5 16.5 11.7239 16.5 12C16.5 12.2761 16.7239 12.5 17 12.5Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 12.5C12.2761 12.5 12.5 12.2761 12.5 12C12.5 11.7239 12.2761 11.5 12 11.5C11.7239 11.5 11.5 11.7239 11.5 12C11.5 12.2761 11.7239 12.5 12 12.5Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7 12.5C7.27614 12.5 7.5 12.2761 7.5 12C7.5 11.7239 7.27614 11.5 7 11.5C6.72386 11.5 6.5 11.7239 6.5 12C6.5 12.2761 6.72386 12.5 7 12.5Z",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgChat;
